"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const PageSmall = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.833 2.499c0-.92.746-1.667 1.667-1.667h5c.92 0 1.666.746 1.666 1.667v5c0 .92-.746 1.666-1.666 1.666h-5C1.58 9.165.833 8.42.833 7.5v-5zM2.5 5.832c0-.46.373-.833.833-.833h3.333c.46 0 .834.373.834.833v.833c0 .46-.373.834-.834.834H3.333a.833.833 0 01-.833-.834v-.833zm.833-2.5a.833.833 0 100-1.667.833.833 0 000 1.667z",
  className: "fill"
}));
var _default = exports.default = PageSmall;